<template>
    <div class="challenge-user-item-selected">
        <p class="challenge-user-item-selected__label">RAKİP</p>
        <div class="wr-challenge-user-item-selected-user-content">
            <svg class="challenge-user-item-selected__icon" width="31" height="38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.334 36c0-7.302 5.92-13.222 13.222-13.222 7.303 0 13.222 5.92 13.222 13.222M23.112 9.556A7.556 7.556 0 118 9.556a7.556 7.556 0 0115.11 0z" stroke="#435166" stroke-opacity=".8" stroke-width="3.778" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <div class="challenge-user-item-selected__userdata">
                <span class="challenge-user-item-selected__username">{{ userItem.username }}</span>
                <span class="challenge-user-item-selected__last-activity">{{ this.lastActivity }}</span>
            </div>
        </div>
        <div class="challenge-user-item-selected__stats">
            <div class="challenge-user-item-selected__stat-win">
                <svg class="challenge-user-item-selected__stat-win-icon" width="26" height="28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.788 5.805l-.063-.534h-3.14c.157-1.068.251-2.167.314-3.297.032-.597-.44-1.099-.973-1.099H3.934c-.565 0-1.005.502-.974 1.099.032 1.13.157 2.23.314 3.297H.134l-.094.534c-.031.125-.376 3.328 1.696 6.217 1.35 1.884 3.454 3.171 6.186 3.83.879.88 1.852 1.54 2.888 1.947a100.877 100.877 0 01-.44 3.706h5.119a62.684 62.684 0 01-.471-3.706c1.036-.377 2.01-1.036 2.889-1.946 2.731-.66 4.835-1.947 6.185-3.831 2.073-2.889 1.696-6.092 1.696-6.217zM2.646 11.237c-1.318-1.821-1.475-3.8-1.475-4.741h2.292c.596 2.982 1.664 5.62 3.014 7.598-1.633-.628-2.92-1.601-3.83-2.857zm20.536 0c-.91 1.256-2.198 2.23-3.831 2.857 1.382-2.01 2.418-4.616 3.014-7.598h2.293c0 .941-.189 2.92-1.476 4.74z" fill="#FFC54D"/><path d="M18.252 25.932H7.576a.563.563 0 01-.565-.565v-4.02c0-.314.251-.565.565-.565h10.676c.314 0 .565.252.565.566v4.019a.563.563 0 01-.565.565z" fill="#C19D72"/><path d="M5.975 27.125h13.878a.563.563 0 00.566-.565v-1.193a.563.563 0 00-.566-.566H5.975a.563.563 0 00-.565.566v1.193c0 .282.25.565.565.565z" fill="#A88763"/><path d="M15.426 23.702h-5.024a.363.363 0 01-.377-.376v-.785c0-.22.157-.377.377-.377h5.024c.22 0 .377.157.377.377v.785c0 .22-.189.376-.377.376z" fill="#FFC54D"/></svg>
                <span class="challenge-user-item-selected__stat-win-text">{{ userItem.stats.win }}</span>
            </div>
            <div class="challenge-user-item-selected__stat-lose">
                <svg class="challenge-user-item-selected__stat-lose-icon" width="23" height="27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.484.375C5.142.375 0 5.518 0 11.86c0 3.9 1.95 7.341 4.922 9.417v4.528c0 .453.367.82.82.82h1.64v-2.461a.82.82 0 011.642 0v2.461h1.64v-2.461a.82.82 0 011.64 0v2.461h1.641v-2.461a.82.82 0 111.641 0v2.461h1.64a.82.82 0 00.821-.82v-4.528c2.973-2.076 4.922-5.519 4.922-9.417 0-6.342-5.144-11.485-11.485-11.485z" fill="#E6C9C9"/><path d="M17.68 12.81l-.943-.933.916-.905a.858.858 0 000-1.225.885.885 0 00-1.241 0l-.917.906-.916-.906a.887.887 0 00-1.243 0 .858.858 0 000 1.225l.917.905-.944.932a.859.859 0 000 1.226.885.885 0 001.24 0l.946-.934.944.934a.886.886 0 001.241 0 .859.859 0 000-1.226zm-9.035-.933l.916-.905a.858.858 0 000-1.225.885.885 0 00-1.24 0l-.918.906-.917-.906a.885.885 0 00-1.24 0 .858.858 0 000 1.225l.915.905-.944.932a.86.86 0 000 1.226c.343.338.9.338 1.242 0l.944-.934.945.934a.887.887 0 001.242 0 .86.86 0 000-1.226l-.945-.932z" fill="#CF5757"/><path d="M6.563 25.805v-4.528C3.59 19.2 1.64 15.758 1.64 11.86 1.64 5.794 6.346.84 12.305.416c-.273-.019-.544-.041-.82-.041C5.141.375 0 5.518 0 11.86c0 3.9 1.95 7.341 4.922 9.417v4.528c0 .453.367.82.82.82h1.64a.82.82 0 01-.82-.82z" fill="#CF5757"/></svg>
                <span class="challenge-user-item-selected__stat-lose-text">{{ userItem.stats.lose }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    // Library imports
    import moment from 'moment';
    moment.locale('tr');


    export default {
        props: {
            userItem: { type: Object, default: {
                id: 7,
                username: "testuser101214",
                lastActive: 1739145938,
                stats: {
                    win: 19,
                    lose: 19
                }
            }}
        },

        data(){
            return {
                intervalId: null,
                lastActivity: null,
            };
        },

        mounted(){
            this.lastActivity = moment(this.userItem.lastActive * 1000).fromNow();
            this.intervalId = setInterval(() => {
                this.lastActivity = moment(this.userItem.lastActive * 1000).fromNow();
                console.log("COMPONENT_CHALLENGE_USER_ITEM_SELECTED/MOUNTED/INTERVAL_" + this.intervalId);
            }, 1000);
        },

        unmounted(){
            clearInterval(this.intervalId);
        }
    }
</script>

<style scoped src="@/css/components/challenge-user-item-selected.css"></style>